import * as Yup from 'yup';
import { reverseShape } from 'Helpers/reverse-shape';

export default Yup.object().shape(
  reverseShape({
    fullName: Yup.string().required(),
    bankName: Yup.string().required(),
    bankAccNumber: Yup.string().required(),
    orderNumber: Yup.string().required(),
    productName: Yup.string().required(),
    reason: Yup.string().required()
  })
)